module.exports = __webpack_public_path__ + "static/img/203.c553e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/203.png
// module id = 9Kks
// module chunks = 0